import { z } from 'zod';
/**
 * Prodejni/pronajemni proces nemovitosti (blok 1): nabor -> priprava ->
 * inzerce -> jednani -> uzavreno. Stavy zijou ve workflow_instances
 * (`workflow_type = LISTING_WORKFLOW_TYPE`), tohle je JEDINY zdroj enumu
 * pro API i UI (cs popisky dodava produkt, identifikatory anglicky).
 */
export const LISTING_WORKFLOW_TYPE = 'property_listing';
export const LISTING_STAGES = [
    'intake',
    'preparation',
    'listing',
    'negotiation',
    'closed',
];
export const listingStageSchema = z.enum(LISTING_STAGES);
//# sourceMappingURL=listing.js.map